
export const ACTION_TYPE_SEND_CHATBOT_MESSAGE = 'send_chatbot_message'
export const ACTION_TYPE_TRIGGER_EVENT = 'trigger_event'
export const ACTION_TYPE_LINK_REDIRECTION = 'link_redirection'

export const ACTION_TYPE_LIST = [
  ACTION_TYPE_SEND_CHATBOT_MESSAGE,
  ACTION_TYPE_TRIGGER_EVENT,
  ACTION_TYPE_LINK_REDIRECTION
]

export const ACTION_TRIGGER_EVENT_APPLY_JOB = 'apply_job'
export const SUPPORTED_ACTION_MAP = {
  [ACTION_TYPE_SEND_CHATBOT_MESSAGE]: 'input',
  [ACTION_TYPE_TRIGGER_EVENT]: [ACTION_TRIGGER_EVENT_APPLY_JOB],
  [ACTION_TYPE_LINK_REDIRECTION]: 'input'
}
